import { DatePicker, Form, Modal, Select, Switch, notification } from "antd";
import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import commitPendingInput from "../../utils/commitPendingInput";
import useApi from "../../utils/useApi";
import { describeError } from "./status";

export default function GenerateNowModal({ open, onClose, routine, catalog }) {
  const { createAiReportRuns } = useApi();
  const queryClient = useQueryClient();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) form.resetFields();
  }, [open, routine]);

  const filiais = (catalog?.branches || [])
    .filter(
      (b) =>
        b.client_id === routine?.client &&
        (!routine?.branches?.length || routine.branches.includes(b.id))
    )
    .map((b) => ({
      value: b.id,
      label: `${b.name}${b.store_code ? ` — loja ${b.store_code}` : ""}`,
    }));

  const handleOk = async () => {
    await commitPendingInput();
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }
    const payload = {
      routine_id: routine.id,
      reexecutar: Boolean(values.reexecutar),
    };
    if (values.branch_id) payload.branch_id = values.branch_id;
    if (values.periodo) {
      payload.start = values.periodo[0].format("YYYY-MM-DD");
      payload.end = values.periodo[1].add(1, "day").format("YYYY-MM-DD");
    }
    setSaving(true);
    try {
      const data = await createAiReportRuns(payload);
      const novos = data.runs.filter((r) => r.criado).length;
      const periodo = `Período ${data.periodo_inicio} a ${data.periodo_fim} (fim exclusivo).`;
      if (novos > 0) {
        notification.success({
          message: `${novos} execução(ões) enfileirada(s).`,
          description: `${periodo} O dispatcher roda a cada 5 minutos.`,
        });
      } else {
        notification.info({
          message: "Nada novo para enfileirar.",
          description: `${periodo} Já existe execução para este período — procure na lista abaixo, pela data de criação. Relatório já concluído não é refeito, para não gastar o provider de novo.`,
        });
      }
      queryClient.invalidateQueries({ queryKey: ["ai-report-runs"] });
      onClose();
    } catch (err) {
      notification.error({
        message: "Não foi possível enfileirar.",
        description: describeError(err, ""),
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      title={`Gerar agora — ${routine?.name || ""}`}
      onOk={handleOk}
      onCancel={onClose}
      okText="Enfileirar"
      confirmLoading={saving}
      destroyOnClose>
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          name="branch_id"
          label="Filial"
          extra="Vazio = todas as filiais da rotina.">
          <Select allowClear options={filiais} placeholder="Todas as filiais" />
        </Form.Item>
        <Form.Item
          name="periodo"
          label="Período"
          extra="Vazio = período natural da rotina (última janela completa até ontem).">
          <DatePicker.RangePicker
            format="DD/MM/YYYY"
            style={{ width: "100%" }}
          />
        </Form.Item>
        <Form.Item
          name="reexecutar"
          label="Reabrir execuções que falharam neste período"
          valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
}
